/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popHowWorks.vue?vue&type=template&id=64d12cfe"
import script from "./popHowWorks.vue?vue&type=script&lang=js"
export * from "./popHowWorks.vue?vue&type=script&lang=js"
import style0 from "./popHowWorks.vue?vue&type=style&index=0&id=64d12cfe&prod&lang=scss"
import style1 from "./popHowWorks.vue?vue&type=style&index=1&id=64d12cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports